// extracted by mini-css-extract-plugin
module.exports = {"spaceAtBottom":"Navbar_spaceAtBottom__2zgwZ"};